"use client";

import { useEffect, useState } from "react";
import ProductDisplay from "../../components/product_display";

// Define TypeScript interfaces for our data
interface Brand {
  id: string;
  name: string;
}

interface Product {
  id: string;
  title: string;
  image: string;
  category: string;
}

export default function Products() {
  const [brands, setBrands] = useState<Brand[]>([]);
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    // In a real application, you would fetch this from an API
    // For demonstration, we're importing the JSON file directly
    const fetchData = async () => {
      try {
        // Fetch data from the JSON file
        const response = await fetch("/assets/json/product-data.json");
        const data = await response.json();
        setBrands(data.brands);
        setProducts(data.products);
        setLoading(false);
      } catch (error) {
        console.error("Error loading product data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div>Loading product data...</div>;
  }
  return (
    <main>
      {/* <div className="hidden w-full pt-16 px-10 lg:flex justify-end ">
        <button
          onClick={() =>
            (window.location.href = "https://ph.parker.com/in/en/category")
          }
          className="px-4 py-2 rounded-full border text-pink-700 border-pink-700"
        >
          
          Browse {selectedBrand} Products
        </button>
      </div> */}
      {/* <div className="w-full pt-8 px-10 flex justify-end lg:justify-end">
        <button  onClick={() => (window.location.href = "https://ph.parker.com/in/en/category")}
        className="px-4 py-2 rounded-full border text-pink-700 border-pink-700">
          Browse Parker Products
        </button>
      </div> */}

      
      <ProductDisplay brands={brands} products={products} />
    </main>
  );
}
